import { TRANSACTIONS, CUSTOMERS } from '../../../_mock/data';
import { TransactionTypes, CustomerTypes } from '../../../_mock/@types';

export const chartData = CUSTOMERS.map((customer: CustomerTypes) => ({
  customerName: customer.name,
  completedTransactionsAmount: TRANSACTIONS.filter(
    (transaction: TransactionTypes) =>
      transaction.paid === true && transaction.customerId === customer.id
  ).reduce((prevValue, currValue) => prevValue + currValue.amount, 0),
  pendingTransactionsAmount: TRANSACTIONS.filter(
    (transaction: TransactionTypes) =>
      transaction.paid === false && transaction.customerId === customer.id
  ).reduce((prevValue, currValue) => prevValue + currValue.amount, 0),
}));
